import { ExerciseEntity } from "./exercise.entity";

export class SectionEntity {
  title: string;
  section: string;
  exercises: ExerciseEntity[];

  constructor(title: string, section: string) {
    this.title = title;
    this.section = section;
    this.exercises = [];
  }

  addExercise(exercise: ExerciseEntity) {
    this.exercises.push(exercise);
  }

  addExercises(exercises: ExerciseEntity[]) {
    this.exercises = [...this.exercises, ...exercises];
  }
}
